<fcom-icon-button
  [size]="size()"
  [aria]="{ label: ariaLabel() }"
  [icon]="{ name: copied() ? SvgLibraryIcon.CHECKMARK : SvgLibraryIcon.COPY }"
  [theme]="IconButtonTheme.LIGHT_TERTIARY_GHOST"
  (clickBtn)="copy()"
  data-testid="copy-text-button"
/>
<span class="is-vishidden" aria-live="polite">
  @if (copied()) {
    {{ copiedLabel() }}
  }
</span>
